<template>
  <div>
    <two-factor-authentication
      v-if="show2faForm"
      ref="twoFactorAuthentication"
      :temp-user="tempUser"
      @handle-login-success="handleLoginSuccess"
    ></two-factor-authentication>
    <login-form
      v-else
      ref="loginForm"
      :selected-user="selectedUser"
      :logged-in-usernames-exist="usernames.length > 0"
      @show-2fa="show2fa"
      @select-usernames="$emit('update:window', 'selectuser')"
    ></login-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoginForm from "./LoginForm";
import TwoFactorAuthentication from "./TwoFactorAuthentication";

export default {
  name: "LoginSection",
  components: {
    LoginForm,
    TwoFactorAuthentication,
  },
  props: {
    selectedUser: {
      type: String,
      required: false,
      default: null,
    },
    usernames: {
      type: Array,
      required: true,
    },
    force2faLogin: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    show2faForm: false,
    username: "",
    staySignedIn: false,
    tempUser: null,
  }),
  methods: {
    show2fa(data) {
      this.username = data.username;
      this.staySignedIn = data.user.staySignedIn;
      if (data.user.needs2FA || this.force2faLogin) {
        this.tempUser = data.user;
        this.show2faForm = true;
      } else {
        data.user.loggedIn2fa = false;
        this.handleLoginSuccess(data);
      }
    },
    handleLoginSuccess(data) {
      data.user.staySignedIn = this.staySignedIn;
      this.updateUsernames(this.username);
      this.updateStoreStates(data.user);
      this.$router.push({ name: "dashboard" });
    },
    updateStoreStates(user) {
      this.setUser(user);
      this.setConnection(user.cloudData[0]);
    },
    updateUsernames(username) {
      const newUserNames = JSON.parse(JSON.stringify(this.usernames));
      const usernameIndex = newUserNames.indexOf(username);
      if (usernameIndex !== 0) {
        if (usernameIndex === -1) {
          newUserNames.unshift(username);
        } else if (usernameIndex > 0) {
          newUserNames.splice(usernameIndex, 1);
          newUserNames.unshift(username);
        }
        this.$emit("update:usernames", newUserNames);
      }
    },
    ...mapActions(["setUser", "setConnection"]),
  },
};
</script>
